import DelegatedTooltip from './DelegatedTooltip';

export default DelegatedTooltip;
